// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh; /* Adjust this as needed */
  }
  :host {
    font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
  }
  mat-spinner {
    margin: auto;
    position: absolute; /* Add this line */
    top: 50%; /* Add this line */
    left: 50%; /* Add this line */
    transform: translate(-50%, -50%); /* Add this line */
  }
  .center-content {
    margin: auto !important;
    text-align: center;
  }
  .material-table-scrollbar {
    overflow: visible;
    height: auto;
  }
  .searchFilter{
    display: grid;
    padding-bottom: 10px;
  }

  .red-icon {
    color: red;
  }
  .container{
    width:100%;
   background-color: white;
   font-weight: bold;
 }
 .bold-text{
  font-weight: bold;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

 }
 .sub-container1{
  width:100%;
  border:2px solid rgb(230, 225, 225);
  background-color:rgb(240, 240, 240);
  border-radius:10px;
  margin:0%;
  padding-left: 2%;
  padding-right: 2%;
  padding: 2%;
}
 .sub-container2{
  width:100%;
  border:2px solid  #286090;
  border-radius:10px;
  margin:2% 0%;
}
.select-text
{
    color:white;
    background-color: #286090;
    border-radius: 5px 5px 0 0;
    text-align: left;
    padding-left:1%;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.table-padding{
    margin: 1%;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px; /* Adjust as needed */
}


 `, "",{"version":3,"sources":["webpack://./src/app/admin/approvedoa/approveandrevokepermanentdoa.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa,EAAE,0BAA0B;EAC3C;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,YAAY;IACZ,kBAAkB,EAAE,kBAAkB;IACtC,QAAQ,EAAE,kBAAkB;IAC5B,SAAS,EAAE,kBAAkB;IAC7B,gCAAgC,EAAE,kBAAkB;EACtD;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,UAAU;GACX,uBAAuB;GACvB,iBAAiB;CACnB;CACA;EACC,iBAAiB;EACjB,2DAA2D;;CAE5D;CACA;EACC,UAAU;EACV,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;CACC;EACC,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;;IAEI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,UAAU;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB,EAAE,qBAAqB;AACzC","sourcesContent":[".spinner-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh; /* Adjust this as needed */\n  }\n  :host {\n    font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n  }\n  mat-spinner {\n    margin: auto;\n    position: absolute; /* Add this line */\n    top: 50%; /* Add this line */\n    left: 50%; /* Add this line */\n    transform: translate(-50%, -50%); /* Add this line */\n  }\n  .center-content {\n    margin: auto !important;\n    text-align: center;\n  }\n  .material-table-scrollbar {\n    overflow: visible;\n    height: auto;\n  }\n  .searchFilter{\n    display: grid;\n    padding-bottom: 10px;\n  }\n\n  .red-icon {\n    color: red;\n  }\n  .container{\n    width:100%;\n   background-color: white;\n   font-weight: bold;\n }\n .bold-text{\n  font-weight: bold;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n }\n .sub-container1{\n  width:100%;\n  border:2px solid rgb(230, 225, 225);\n  background-color:rgb(240, 240, 240);\n  border-radius:10px;\n  margin:0%;\n  padding-left: 2%;\n  padding-right: 2%;\n  padding: 2%;\n}\n .sub-container2{\n  width:100%;\n  border:2px solid  #286090;\n  border-radius:10px;\n  margin:2% 0%;\n}\n.select-text\n{\n    color:white;\n    background-color: #286090;\n    border-radius: 5px 5px 0 0;\n    text-align: left;\n    padding-left:1%;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.table-padding{\n    margin: 1%;\n}\n\n.truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 150px; /* Adjust as needed */\n}\n\n\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
